import {createAsyncThunk} from "@reduxjs/toolkit";
import {AxiosResponse} from "axios";
import instance from "@/config/axios";
import { serializeQueryParam } from '@/utils';

export const getCountCsvUrl = createAsyncThunk('countCsv/getUrl',
  async ({ reportStartDate, reportEndDate, graphType, venueId }: any) => {
    const url = `/v1/reports/count-graph/download${serializeQueryParam({
      startDate: reportStartDate,
      endDate: reportEndDate,
      countGraphType: graphType,
      venueId
    })}`
    const response: AxiosResponse<{url: string}> = await instance.get(url)
    return response
  })
